var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0C5DA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98117 18.0156C10.6048 17.1213 12.4173 16.3748 14.1108 15.6245C17.0242 14.3957 19.9492 13.1881 22.9038 12.0638C23.4786 11.8723 24.5115 11.685 24.6128 12.5369C24.5573 13.7427 24.3291 14.9415 24.1727 16.1403C23.7755 18.7765 23.3165 21.4037 22.8688 24.0312C22.7146 24.9065 21.6182 25.3595 20.9166 24.7994C19.2307 23.6606 17.5318 22.5329 15.8673 21.3677C15.3221 20.8137 15.8277 20.0181 16.3146 19.6225C17.7032 18.254 19.1759 17.0913 20.4919 15.6521C20.8469 14.7949 19.798 15.5174 19.452 15.7387C17.551 17.0487 15.6965 18.4387 13.6923 19.5901C12.6685 20.1536 11.4753 19.672 10.452 19.3576C9.53447 18.9777 8.18995 18.5949 8.98107 18.0157L8.98117 18.0156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTg);
export default __webpack_public_path__ + "static/media/footer-tg.619391527e87f31e72070eb30fecf7c0.svg";
export { ForwardRef as ReactComponent };